import parse from "html-react-parser";
import useMediaQueries from "hooks/useMediaQueries.js";

import "./Support.scss";

const SpecificQuestion = (props) => {
  const { mobileCondition } = useMediaQueries();
  return (
    <div className="support-questions">
      <div className="support-questions-title-container">
        <h1 className=" single-question-title">{props.question.Title}</h1>
      </div>
      <div className="support-questions-section-container questions-text-container">
        {parse(
          props.question.AnswerText
            ? props.question.AnswerText.replaceAll(
                `width="560"`,
                mobileCondition ? `width="100%"` : `width="560"`
              )
            : ""
        )}
      </div>
    </div>
  );
};

export default SpecificQuestion;
